(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design_inspriration"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initSwiper() {
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper not defined');
        return;
      }

      const baseOptions = {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        coverflowEffect: {
          rotate: 25,
          stretch: 0,
          depth: 180,
          modifier: 1,
          slideShadows: false,
        },
      };

      document.querySelectorAll('.swiper-design1').forEach((el) => {
        if (el.swiper) el.swiper.destroy(true, true);
        new Swiper(el, baseOptions);
      });

      document.querySelectorAll('.swiper-insp').forEach((el) => {
        if (el.swiper) el.swiper.destroy(true, true);
        new Swiper(el, baseOptions);
      });
    }

    initSwiper();

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.swiper')) {
        initSwiper();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["desktop-shop-by-categories"] && !Shopify.designMode) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function() {
  const totalSlides = document.querySelectorAll('.desk-shopcat-slide').length;
  if (totalSlides === 0) return;
  
  var mySwiper = new Swiper ('.desk-shopcat-swiper', {
  slidesPerView : 4, 
  loop: true,
  centeredSlides : true,
  autoplay: {
        delay: 3000,
    },
  effect: 'coverflow',
  coverflow: {
            rotate: 10,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows : true
        },
  
      scrollbar: {
      el: ".desk-shopcat-scrollbar",
      draggable: true,
      hide: false,
      snapOnRelease: true}
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events"] && !Shopify.designMode) return;
  try {
    
        document.addEventListener('DOMContentLoaded', function() {
          const swiper = new Swiper('#events-swiper-{{ section.id }}', {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
              nextEl: '#events-swiper-{{ section.id }} .swiper-button-next',
              prevEl: '#events-swiper-{{ section.id }} .swiper-button-prev',
            },
            breakpoints: {
              640: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 30,
              }
            }
          });
        });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hall-of-fame-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hallOfFameSwiper = new Swiper('.hall-of-fame-swiper', {
      loop: true,
      pagination: {
        el: '.hall-of-fame-swiper .swiper-pagination',
        clickable: true,
      },
      scrollbar: {
        el: '.hall-of-fame-scrollbar',
        draggable: true,
        hide: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-categories"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initShopCatSwiper(section) {
    if (!window.Swiper) return;

    const swiperEl = section.querySelector('.shopcat-swiper');
    if (!swiperEl) return;

    // Prevent duplicate init
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slides = swiperEl.querySelectorAll('.shopcat-slide');
    if (slides.length === 0) return;

    new Swiper(swiperEl, {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: slides.length > 1,
      slidesPerView: "auto",
      speed: 800,
      autoplay: {
        delay: 2000,
      },

      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 200,
        modifier: 1.5,
        slideShadows: false,
      },

      scrollbar: {
        el: swiperEl.querySelector('.shopcat-scrollbar'),
        draggable: true,
        hide: false,
        snapOnRelease: true
      }
    });
  }

  function initAllShopCatSections() {
    document.querySelectorAll('.shop-categories-section').forEach(section => {
      initShopCatSwiper(section);
    });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', initAllShopCatSections);

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (event) {
    initShopCatSwiper(event.target);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-range"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class ShopByRange {
      constructor(section) {
        this.section = section;
        this.tabs = section.querySelectorAll('.shop-by-range__tab');
        this.panels = section.querySelectorAll('.shop-by-range__panel');
        this.currentTab = 0;
        this.instances = [];

        this.init();
      }

      init() {
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.switchTab(i));
        });

        this.panels.forEach((panel, i) => {
          const slider = new SwipeSlider(panel);
          this.instances.push(slider);
        });
      }

      switchTab(i) {
        this.tabs[this.currentTab].classList.remove('active');
        this.panels[this.currentTab].classList.remove('active');

        this.currentTab = i;

        this.tabs[this.currentTab].classList.add('active');
        this.panels[this.currentTab].classList.add('active');

        this.instances[i].refresh();
      }
    }

    class SwipeSlider {
      constructor(panel) {
        this.panel = panel;
        this.grid = panel.querySelector('[data-products-grid]');
        this.progress = panel.querySelector('.shop-by-range__progressbar');

        this.index = 0;
        this.itemsPerView = 4;
        this.startX = 0;
        this.currentX = 0;
        this.dragging = false;

        this.init();
      }

      init() {
        this.calculate();
        this.buildDots();
        this.update(true);

        this.grid.addEventListener('touchstart', (e) => this.down(e.touches[0].clientX, e), { passive: true });
        this.grid.addEventListener('touchmove', (e) => this.move(e.touches[0].clientX, e), { passive: false });
        this.grid.addEventListener('touchend', () => this.up());
        this.grid.addEventListener('touchcancel', () => this.up());

        this.grid.addEventListener('mousedown', (e) => this.down(e.clientX, e));
        window.addEventListener('mousemove', (e) => this.move(e.clientX, e));
        window.addEventListener('mouseup', () => this.up());

        // After a real drag, cancel the one click that would fire on touchend
        // so the swipe doesn't open the product under the finger.
        this.grid.addEventListener('click', (e) => {
          if (this.moved) {
            e.preventDefault();
            e.stopPropagation();
            this.moved = false;
          }
        }, true);

        // Native image dragging (desktop) fights the slider — disable it.
        this.grid.querySelectorAll('img').forEach((img) => { img.draggable = false; });

        window.addEventListener('resize', () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.refresh(), 300);
        });
      }

      calculate() {
        this.itemsPerView = window.innerWidth < 750 ? 1.2 : 4;
        const cards = this.grid.querySelectorAll('.shop-by-range__product-card');
        this.totalSlides = cards.length;

        // Total pages is total slides minus items per view to avoid empty space at the end
        // For infinite loop logic, we use totalSlides
        this.maxIndex = Math.max(0, this.totalSlides - Math.floor(this.itemsPerView));

        if (cards.length > 0) {
          this.cardWidth = cards[0].getBoundingClientRect().width;
          this.gap = parseFloat(getComputedStyle(this.grid).gap) || 0;
          this.slideWidth = this.cardWidth + this.gap;
        }
      }

      down(x, e) {
        // A drag can start ANYWHERE on the carousel — including on top of the
        // product images and links. A tap (no movement) still clicks through
        // normally; once the finger moves, the follow-up click is suppressed
        // (capture listener in init) so a swipe never opens a product.
        if (e && e.type === 'mousedown') e.preventDefault();
        this.startX = x;
        this.moved = false;
        this.dragging = true;
        this.grid.style.transition = 'none';
      }

      move(x, e) {
        if (!this.dragging) return;
        this.currentX = x;
        const diff = this.currentX - this.startX;
        if (Math.abs(diff) > 8) {
          this.moved = true;
          // The gesture is clearly horizontal — take it over from the browser
          // so the page doesn't scroll vertically mid-swipe.
          if (e && e.cancelable) e.preventDefault();
        }
        this.grid.style.transform = `translateX(calc(${-this.index * this.slideWidth}px + ${diff}px))`;
      }

      up() {
        if (!this.dragging) return;
        this.dragging = false;

        const diffX = this.currentX - this.startX;

        if (this.currentX !== 0 && Math.abs(diffX) > 50) {
          if (diffX < 0) {
            this.index = this.index >= this.maxIndex ? 0 : this.index + 1;
          } else {
            this.index = this.index <= 0 ? this.maxIndex : this.index - 1;
          }
        }

        this.currentX = 0;
        this.update();
      }

      buildDots() {
        if (!this.progress) return;
        this.progress.innerHTML = '';
        // Only show dots for available "steps"
        for (let i = 0; i <= this.maxIndex; i++) {
          const dot = document.createElement('div');
          dot.className = 'shop-by-range__progress-dot';
          if (i === this.index) dot.classList.add('active');
          dot.addEventListener('click', () => {
            this.index = i;
            this.update();
          });
          this.progress.appendChild(dot);
        }
      }

      update(noAnim = false) {
        this.grid.style.transition = noAnim ? 'none' : 'transform 0.6s cubic-bezier(0.22, 0.61, 0.36, 1)';
        this.grid.style.transform = `translateX(${-this.index * this.slideWidth}px)`;
        this.updateDots();
      }

      updateDots() {
        if (!this.progress) return;
        const dots = this.progress.querySelectorAll('.shop-by-range__progress-dot');
        dots.forEach((dot, i) => dot.classList.toggle('active', i === this.index));
      }

      refresh() {
        this.calculate();
        this.buildDots();
        this.update(true);
      }
    }

    document.querySelectorAll('.shop-by-range').forEach((section) => {
      new ShopByRange(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_10_picks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperElement = document.querySelector('.tp-slider');
    if (! swiperElement) return;
    

    const swiper = new Swiper(swiperElement, {
      loop: false,
      grabCursor: false,
      initialSlide: 0,
      slidesPerView: 1.5,
      spaceBetween: 10,
      centeredSlides: false,

// pagination: {
// el: '.tp-progressbar',
// clickable: true,
// bulletClass: 'tp-dot',
// bulletActiveClass: 'active',
// renderBullet: function (index, className) {
// return '<span class="' + className + '"></span>';
// },
// },

      scrollbar: {
        el: '.tp-scrollbar',
        draggable: true,
        hide: false
      },

      breakpoints: {

        // Tablet
        751: {
          slidesPerView: 2.5,
          spaceBetween: 10
        },

        1024: {
          slidesPerView: 2.5,
          spaceBetween: 10
        },

// Desktop
        1025: {
          slidesPerView: 3.5,
          spaceBetween: 10
        },

// Large Desktop
        1440: {
          slidesPerView: 3.7,
          spaceBetween: 20
        },

        1920: {
          slidesPerView: 4.2,
          spaceBetween: 20
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const storageKey = 'shopify_wishlist';
    const grid = document.getElementById('wishlist-grid');
    const loading = document.getElementById('wishlist-loading');
    const emptyState = document.getElementById('wishlist-empty');
    const countText = document.getElementById('wishlist-count-text');

    // Wishlist functions (unchanged)
    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (e) { return []; }
    }

    function saveWishlist(items) {
      localStorage.setItem(storageKey, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wishlist:update', { detail: { items } }));
    }

    function removeFromWishlist(productId) {
      let items = getWishlist().filter(item => item.id !== productId);
      saveWishlist(items);
      renderWishlist();
      updateWishlistCounts();
    }

    async function fetchCart() {
      try {
        const res = await fetch('/cart.js');
        return await res.json();
      } catch (e) { return { item_count: 0 }; }
    }

    function updateCartCountUI(count) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
        el.style.display = count > 0 ? 'flex' : 'none';
        el.textContent = count < 100 ? count : '99+';
      });
      window.dispatchEvent(new CustomEvent('cart:update', { detail: { count } }));
    }

    // Improved Refresh + Force remove is-empty
    async function refreshCartDrawer() {
      try {
        const response = await fetch('/?sections=cart-drawer');
        const data = await response.json();
        const newHtml = data['cart-drawer'];

        if (!newHtml) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(newHtml, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer, .cart-drawer, #CartDrawer');

        const existingDrawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer, .drawer--cart');
        if (existingDrawer && newDrawer) {
          existingDrawer.innerHTML = newDrawer.innerHTML;

          // CRITICAL FIX: Remove is-empty class and force show content
          existingDrawer.classList.remove('is-empty', 'cart-drawer--is-empty');
          
          const itemsContainer = existingDrawer.querySelector('.cart-drawer-items, cart-drawer-items, .cart__contents, #CartDrawer-Form');
          if (itemsContainer) {
            itemsContainer.classList.remove('is-empty');
          }

          // Re-init the web component if possible
          if (typeof existingDrawer.renderContents === 'function') {
            existingDrawer.renderContents();
          }
          if (typeof existingDrawer.init === 'function') {
            existingDrawer.init();
          }
        }
      } catch (e) {
        console.error('Cart drawer refresh failed:', e);
      }
    }

    async function openAndRefreshCartDrawer() {
      const drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');

      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('is-open', 'active', 'animate');
      } else {
        // Fallback click cart icon
        document.querySelector('.header__icon--cart, .cart-icon, [data-cart-icon]')?.click();
      }

      // Refresh after small delay
      setTimeout(async () => {
        await refreshCartDrawer();
      }, 600);
    }

    // Add to Cart
    async function addToCart(variantId, buttonElement, productId) {
      if (!variantId) return;

      const originalText = buttonElement.textContent;
      buttonElement.classList.add('loading');
      buttonElement.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        });

        const cart = await fetchCart();
        updateCartCountUI(cart.item_count || 0);

        buttonElement.classList.remove('loading');
        buttonElement.classList.add('success');
        // buttonElement.textContent = '✓ Added';

        showNotification('Product added to cart!');

        await openAndRefreshCartDrawer();

        // Uncomment below if you want to auto-remove from wishlist
        // removeFromWishlist(productId);

        setTimeout(() => {
          buttonElement.classList.remove('success');
          buttonElement.textContent = originalText;
          buttonElement.disabled = false;
        }, 2000);

      } catch (e) {
        console.error(e);
        buttonElement.classList.remove('loading');
        buttonElement.disabled = false;
        buttonElement.textContent = originalText;
        showNotification('Failed to add to cart.', true);
      }
    }

    // Rest of your functions (formatMoney, showNotification, fetchProduct, createProductCard, renderWishlist, event listeners) remain the same
    function formatMoney(cents) {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }).format(cents / 100);
    }

    function showNotification(message, isError = false) {
      let note = document.querySelector('.wishlist-notification');
      if (note) note.remove();
      note = document.createElement('div');
      note.className = `wishlist-notification${isError ? ' error' : ''}`;
      note.textContent = message;
      document.body.appendChild(note);
      setTimeout(() => note.classList.add('show'), 10);
      setTimeout(() => { note.classList.remove('show'); setTimeout(() => note.remove(), 300); }, 2800);
    }

    async function fetchProduct(handle) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        return res.ok ? await res.json() : null;
      } catch (e) { return null; }
    }

    function createProductCard(product, wishlistItem) {
      const variant = product.variants?.[0];
      if (!variant) return null;

      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      // Cash saved, not a percentage — matches the badges on product cards and
      // product pages. formatMoney already renders whole rupees (no ".00").
      const saved = hasCompare ? variant.compare_at_price - variant.price : 0;

      const card = document.createElement('div');
      card.className = 'wishlist-item';
      card.dataset.productId = wishlistItem.id;

      const imageUrl = product.featured_image || product.images?.[0] || '';

      card.innerHTML = `
        <div class="wishlist-item__media">
          <a href="/products/${product.handle}">
            <img src="${imageUrl}" alt="${product.title}" class="wishlist-item__image" loading="lazy">
          </a>
          <button type="button" class="wishlist-item__remove" data-remove-wishlist="${wishlistItem.id}" aria-label="Remove">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
        <div class="wishlist-item__info">
          <div class="wishlist-item__top-info">
            ${product.tags?.[0] ? `<span class="wishlist-item__category">${product.tags[0]}</span>` : ''}
            ${hasCompare ? `<span class="wishlist-item__badge-save">Save ${formatMoney(saved)}</span>` : ''}
          </div>
          <h3 class="wishlist-item__title"><a href="/products/${product.handle}">${product.title}</a></h3>
          <div class="wishlist-item__price">
            ${formatMoney(variant.price)}
            ${hasCompare ? `<span class="wishlist-item__price-compare">${formatMoney(variant.compare_at_price)}</span>` : ''}
          </div>
          <div class="wishlist-item__actions">
            <button type="button" class="wishlist-item__add-to-cart" 
              data-variant-id="${variant.id}" 
              data-product-id="${wishlistItem.id}"
              ${!product.available ? 'disabled' : ''}>
              ${product.available ? 'Add to Cart' : 'Sold Out'}
            </button>
          </div>
        </div>
      `;
      return card;
    }

    async function renderWishlist() {
      const items = getWishlist();
      if (items.length === 0) {
        loading.style.display = 'none';
        grid.style.display = 'none';
        emptyState.style.display = 'block';
        countText.textContent = '0 items';
        return;
      }

      countText.textContent = `${items.length} item${items.length > 1 ? 's' : ''}`;
      loading.style.display = 'none';
      emptyState.style.display = 'none';
      grid.style.display = 'grid';
      grid.innerHTML = '';

      const products = await Promise.all(items.map(item => fetchProduct(item.handle)));
      items.forEach((item, i) => {
        const product = products[i];
        if (product) {
          const card = createProductCard(product, item);
          if (card) grid.appendChild(card);
        }
      });
    }

    // Event listeners
    grid.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-remove-wishlist]');
      if (removeBtn) {
        removeFromWishlist(removeBtn.dataset.removeWishlist);
        return;
      }

      const cartBtn = e.target.closest('.wishlist-item__add-to-cart');
      if (cartBtn && !cartBtn.disabled) {
        addToCart(cartBtn.dataset.variantId, cartBtn, cartBtn.dataset.productId);
      }
    });

    // Initialize
    renderWishlist();
    updateWishlistCounts();
    fetchCart().then(cart => updateCartCountUI(cart.item_count || 0));

    function updateWishlistCounts() {
      const count = getWishlist().length;
      document.querySelectorAll('.wishlist-count-bubble').forEach(bubble => {
        bubble.style.display = count > 0 ? 'flex' : 'none';
        bubble.textContent = count < 100 ? count : '99+';
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
